import { render, staticRenderFns } from "./PassportInfoDocsDialog.vue?vue&type=template&id=2d5cd686"
import script from "./PassportInfoDocsDialog.vue?vue&type=script&lang=js"
export * from "./PassportInfoDocsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports